// extracted by mini-css-extract-plugin
module.exports = {"instructions_container":"ChangeCollectionInstructions_instructions_container__2HgeD","instructions":"ChangeCollectionInstructions_instructions__11aAl"};